<template>
  <div :id="scanditBarcodeScannerId" />
</template>

<script>
  import * as ScanditSDK from "scandit-sdk";

  export default {
    name: 'ScanditScanner',
    props: {
      licenseKey: {
        type: String,
        // Web demo default license key - allow module to be evaluated the same way as the Web SDK demo on Scandit's site allows the library to be tested
        default: 'AQjvfCXeBTtdD+3eawdysDo9qrUDIyNkkWjjT+tVf8tcczdAeg+yq8ZpY6MzS9P6KHqLfo9Y94+Yac9RNjZTEGhVTiYBPPNMWnknxc5giYVBA35sAj4MSrpu79sRV/u7ZlywMY47XpGfDf8u7SedkegM2y5MHgHAUN4XVXsoDKpyI48Qz8PI/j4JDURNsI8Q9/JasL34Bmvv4veuI+lB3mLyxj0Evgpxu/EKCzzjCOQkHLWXpWYtjdiSGv8TTvyNba7C7yBigjdAzc0FuQsqWeenJFoPLvRHUReHuaCeVlo5HinNPTJfIlsNtC/dSQJMX2rKJ0tLfL9NShEEhhjS3l6zp2utSpVKgApS0PICvnA5+gmaQjn8q940GAXYHbxSJAswT7xywDoLZeTWzm3xmyQu+wRe247CL1XpTtTzydhUPuIdvr4cjNAp6Y5rJUPX31TJ5V1UmZC/24tT+GJs8ini53ALzDlTfF06hEKLnoEmNI/YEqCzWMNmZsUnMNDJW3LOkIHtQ9EB7bqIJeLppO7MCzyHLA4V2Xrb7mBRueFTykRJHxT14nxE8oN8mZDgdQTZa4ORZFMNygrfmEhWFeKQ4OYvzaOLP1A009v3+eObZHlwMSn1LAW5xajuzWN/Uz8HbZmNsX8xponJYEqwDsLFXMd9Oe2I5h71WR6Tl9l99WtHAXIDPpOy2RtYcJEP9ERHEg5FpmbOfHuIWgDcd/Hz2uDX0pJC/2C3d6ItKAEFKQVOt7wrAPjvmDDqKPksPGBN29r6RVf8RZCHqyaJxisA5t5lRW78oaIcHcwSZKBTBgQbjeg3OPnYBiMW6iNjnb4=',
        //default: 'AcUf4BkjOXAQCeCwDhcl05QwFCPbKhuZ5FtZI15e7zbeYfJ8Ynj2LbM3eYRKVc5BX16tlqp9HQJKVBFiV3EmqJ9KHZNURfjjHkVJWLJA+pXydYUG0mpdQ6N8nIgtRUINTWMGrSxC7RTlEY/ntyFnmJk/yQndKawusD0q5w+jE/9ijD+nchPLf+ampYOTAoz2E3GImauEFvJ/O2lvPYrWjziw6c4nxGcjgT09AbFpiXjUbIWP9FrT3Y8PEfRmXueZRCy9kMUG1wgK0JJwv9eKnc8wb0dX/B0Mt3UWZiz9AuiU4qd5LIK0B7BmGIuUIRYfSqjuslnfetc+8Y/Wzqy6eYwTsb01dsH8J9Y0RUlGTznknWXkG5AhrB30TlpEd++aTsihJTrlXcGqXCNz2ZNxlHuu+FUdiN6NMxg8QyIHKsU5EcWFHTmMJ0hQfRvgo6EviycOcUWDKBBNRNHqXugPoV5WqOK7LMx3H9SApg6+Ekfm8RHxCUTm3XpM/j6t0DT9cBoolQPlbk3vkpeJAy5az3KkboKejX7DvJL674zAl+M0/lbTs4iLa+GwZvSBGZq3j38oRj+qcIfYIPHLFo2J0xzXyswsOli33LMQt40K3PL5sisGtcYaa5jQHfUtRSzFrn9CVMt8yVhrHGxnVHWihim8XZG5ZamLThoXg9rd/UM++zloxVYfXwDs752PcC/86WExBKsVES/acZk2dNUl4hsi7pvxQl+FaZa5WOw0b1DHfPfI49B3ObfAMB1zGv3fUfyVSYBdk7e3RQB3ZnyKpwctfHkzEUy8t4vKB5QTGEkRveW2KCGlESfubeNU0Qn5jyv922vjKUkk',
        required: false
      },
      configurationOptions: {
        type: Object,
        default: () => ({
          engineLocation: 'https://cdn.jsdelivr.net/npm/scandit-sdk@5.x/build/',
        }),
        required: false
      },
      scanSettings: {
        type: Object,
        default: () => ({
          enabledSymbologies: ["ean8", "ean13", "upca", "upce", "code128", "code39", "code93", "itf"],
        }),
        required: false
      },
      startScan: Boolean
    },
    mounted() {
      //console.log(ScanditSDK.Barcode.Symbology);
    },
    beforeDestroy() {
      //console.log("beforeDestroy triggered.");
      this.stopScandit();
    },
    data: () => ({
      barcodePicker: null,
    }),
    computed: {
      scanditBarcodeScannerId: function () {
        return "scandit-barcode-scanner" + this.guidGenerator()
      }
    },
    watch: {
      startScan: function (newValue, oldValue) {
        //console.log("ScanditScanner - startScan changed: " + newValue);

        if (newValue) {
          try {
            if (!this.barcodePicker || this.barcodePicker.destroyed) {
              this.startScandit();
            }
            else {
              this.resumeScanning();
            }
          }
          catch (err) {
            console.log(err);
          }
        }
        else {
          //this.stopScandit();
          this.pauseScanning();
        }
        this.$emit('update:startScan', newValue);
      },
      licenseKey: function (newValue, oldValue) {
        this.resetScandit();
      },
      configurationOptions: function (newValue, oldValue) {
        this.resetScandit();
      },
      scanSettings: function (newValue, oldValue) {
        //console.log("ScanditScanner - scanSettings", newValue);
        this.resetScandit();
      },
    },
    methods: {
      startScandit() {
        ScanditSDK.configure(this.licenseKey, this.configurationOptions)
          .then(() => {
            return ScanditSDK.BarcodePicker.create(document.getElementById(this.scanditBarcodeScannerId), {
              // enable some common symbologies
              scanSettings: new ScanditSDK.ScanSettings(this.scanSettings),
            });
          })
          .then((barcodePicker) => {
            this.barcodePicker = barcodePicker;
            //this.$emit('barcodePicker', barcodePicker);
            // barcodePicker is ready here, show a message every time a barcode is scanned
            barcodePicker.on('scan', (scanResult) => {
              this.$emit('get-detected-code', scanResult.barcodes[0].data);
              this.startScan = false;
              //this.$emit('update:startScan', false);
            });
          });
      },
      stopScandit() {
        if (this.barcodePicker) {
          this.barcodePicker.accessCamera = false;
          this.barcodePicker.destroy();
        }
        //console.log(this.barcodePicker);
        //console.log(this.barcodePicker.destroyed);
      },
      resumeScanning() {
        if (this.barcodePicker && !this.barcodePicker.destroyed) {
          this.barcodePicker.accessCamera();
          this.barcodePicker.resumeScanning();
        }
      },
      pauseScanning() {
        if (this.barcodePicker && !this.barcodePicker.destroyed) {
          this.barcodePicker.pauseScanning(true);
        }
      },
      resetScandit() {
        this.stopScandit();
        this.startScan = false;
      },
      guidGenerator() {
        var S4 = function () {
          return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EcomCore/Components/InputDevices/ScanditBarcodeScanner.vue